export const DeliveringBadgeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 8C18 12.42 14.42 16 10 16C5.58 16 2 12.42 2 8C2 3.58 5.58 0 10 0C14.42 0 18 3.58 18 8ZM10 2C6.69 2 4 4.69 4 8C4 11.31 6.69 14 10 14C13.31 14 16 11.31 16 8C16 4.69 13.31 2 10 2Z"
      fill="currentColor"
    />
    <path
      d="M10.5 4H9V9L13.25 11.5L14 10.26L10.5 8.25V4Z"
      fill="currentColor"
    />
  </svg>
);
